import { render, staticRenderFns } from "./LuckDetailForm.vue?vue&type=template&id=4813a251&scoped=true"
import script from "./LuckDetailForm.vue?vue&type=script&lang=js"
export * from "./LuckDetailForm.vue?vue&type=script&lang=js"
import style0 from "./LuckDetailForm.vue?vue&type=style&index=0&id=4813a251&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813a251",
  null
  
)

export default component.exports